var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","py-0":"","px-0":""}},[_c('u-i-toolbar-admin',{attrs:{"title":"Not arrived orders","icon":"as fa-file-alt"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }